import CambiarClavePage from "features/private/configuracion/pages/cambiar-clave.page";
import PagosIndividualPage from "features/private/pagos/pages/pagos-individual.page";
import PagosMultiplesPage from "features/private/pagos/pages/pagos-multiples.page";
import PagosPage from "features/private/pagos/pages/pagos.page";
import LoginPage from "features/public/login/pages/login.page";
import { Route, Routes } from "react-router-dom";
import MainLayout from "./components/layouts/main-layout/main-layout";
import PagosECheckPage from "./features/private/pagos/pages/pagos-echeck.page";
import PagosPayworksPage from "./features/private/pagos/pages/pagos-payworks.page";
import { DatosConfiguracion } from "./features/public/common/api/common.api";
import NotFoundPage from "./features/public/common/pages/not-found.page";
import RegistrarUsuarioPage from "./features/public/common/pages/registrar-usuario.page";
import RestablecerClavePage from "./features/public/common/pages/restablecer-clave.page";
import { isDatosConfiguracion, useRouting } from "./hooks/with-routing";

const configurarCss = (configuracion: DatosConfiguracion) => {
	document.documentElement.style.setProperty('--color-banner', configuracion.colorBanner);
	document.documentElement.style.setProperty('--color-pantalla-fondo', configuracion.colorFondoPantalla);
	document.documentElement.style.setProperty('--color-pantalla-letra', configuracion.colorLetraPantalla);
	document.documentElement.style.setProperty('--color-menu-sinseleccion-fondo', configuracion.colorFondoMenu);
	document.documentElement.style.setProperty('--color-menu-sinseleccion-letra', configuracion.colorLetraMenu);
	document.documentElement.style.setProperty('--color-menu-seleccion-fondo', configuracion.colorFondoMenuTabla);
	document.documentElement.style.setProperty('--color-menu-seleccion-letra', configuracion.colorLetraMenuTabla);
	document.documentElement.style.setProperty('--color-registro-seleccion-fondo', configuracion.colorFondoRegistro);
	document.documentElement.style.setProperty('--color-registro-seleccion-letra', configuracion.colorLetraRegistro);
	document.documentElement.style.setProperty('--btn-primary-fondo', configuracion.colorFondoBotonPrimario);
	document.documentElement.style.setProperty('--btn-primary-color', configuracion.colorLetraBotonPrimario);
	document.documentElement.style.setProperty('--btn-secondary-fondo', configuracion.colorFondoBotonSecundario);
	document.documentElement.style.setProperty('--btn-secondary-color', configuracion.colorLetraBotonSecundario);
};

function App() {
	const config = useRouting.use.configuration();
	isDatosConfiguracion(config) && configurarCss(config);

	return (
		<Routes>
			<Route path="/404"
				element={
					<NotFoundPage />
				}
			/>
			<Route path="/:segmento/login"
				element={
					<LoginPage />
				}
			/>
			<Route path="/:segmento/registrarse"
				element={
					<RegistrarUsuarioPage />
				}
			/>
			<Route path="/:segmento/restablecer-clave"
				element={
					<RestablecerClavePage />
				}
			/>
			<Route element={<MainLayout />}>
				<Route path="/:segmento/"
					element={
						<PagosPage />
					}
				/>
				<Route path="/:segmento/pagos"
					element={
						<PagosPage />
					}
				/>
				<Route path="/:segmento/cambiar-clave"
					element={
						<CambiarClavePage />
					}
				/>
				<Route path="/:segmento/pagos/individual"
					element={
						<PagosIndividualPage />
					}
				/>
				<Route path="/:segmento/pagos/multiples"
					element={
						<PagosMultiplesPage />
					}
				/>
			</Route>
			<Route path="/:segmento/pagos/echeck"
				element={
					<PagosECheckPage />
				}
			/>
			<Route path="/:segmento/pagos/payworks"
				element={
					<PagosPayworksPage />
				}
			/>
			<Route path="*"
				element={
					<NotFoundPage />
				}
			/>
			{/*<Route element={<MainLayoutDisabled />}>*/}
			{/*	<Route path="/"*/}
			{/*		element={*/}
			{/*			<ProtectedRoute>*/}
			{/*				<PagosPage />*/}
			{/*			</ProtectedRoute>*/}
			{/*		}*/}
			{/*	/>*/}
			{/*</Route>*/}
		</Routes>
	);
}

export default App;